import React from "react";

import { Card, Icon } from "@stellar/design-system";

import { Box } from "@/components/Box";
import { Title } from "@/components/Title";

import "./styles.scss";

interface WalletCardProps {
  walletName: string;
  homepageUrl: string;
  assets: string[];
  userManaged: boolean | undefined;
}

export const WalletCard: React.FC<WalletCardProps> = ({
  walletName,
  homepageUrl,
  assets,
  userManaged,
}: WalletCardProps) => {
  const walletNameLetter = walletName?.charAt(0).toUpperCase() || "W";

  return (
    <Card noPadding>
      <div className="WalletCard">
        <div className="WalletCard__title">
          <div className="WalletCard__item">
            <div className="WalletCard__item">
              <div className="WalletCard__icon">{walletNameLetter}</div>

              <Title size="md">{walletName}</Title>

              <a
                className="WalletCard__ExternalLink"
                href={homepageUrl}
                target="_blank"
                rel="noreferrer noopener"
              >
                <Icon.LinkExternal01 className="ExternalLinkIcon" />
              </a>
            </div>
          </div>
        </div>

        <div className="WalletCard__walletData">
          <Box gap="md" direction="row" align="center" justify="space-between">
            <div className="WalletCard--flexCols">
              <label className="WalletCard__item__label">Supported:</label>
              <div className="WalletCard__item__value">{assets?.join(", ")}</div>
            </div>
          </Box>
          <div className="WalletCard--flexCols">
            <label className="WalletCard__item__label">User Managed:</label>
            <div className="WalletCard__item__value">{userManaged ? "Yes" : "No"}</div>
          </div>
        </div>
      </div>
    </Card>
  );
};
